var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgContrastTool = function SvgContrastTool(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6ZM16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24V8Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6ZM16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8V6H18V8H16ZM16 24H18V26H16V24ZM4 16C4 9.37258 9.37258 4 16 4V8C11.5817 8 8 11.5817 8 16H4ZM16 28C9.37258 28 4 22.6274 4 16H8C8 20.4183 11.5817 24 16 24V28ZM28 16C28 22.6274 22.6274 28 16 28V24C20.4183 24 24 20.4183 24 16H28ZM16 4C22.6274 4 28 9.37258 28 16H24C24 11.5817 20.4183 8 16 8V4ZM6 16C6 10.4772 10.4772 6 16 6V10C12.6863 10 10 12.6863 10 16H6ZM16 26C10.4772 26 6 21.5228 6 16H10C10 19.3137 12.6863 22 16 22V26ZM18 8V24H14V8H18Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContrastTool);
export { ForwardRef as ReactComponent };